var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97076 11.1261C7.29826 10.958 7.70174 10.958 8.02924 11.1261L12.4708 13.4056C12.7983 13.5737 13 13.8843 13 14.2205V19.7795C13 20.1157 12.7983 20.4263 12.4708 20.5944L8.02924 22.8739C7.70174 23.042 7.29826 23.042 6.97076 22.8739L2.52924 20.5944C2.20174 20.4263 2 20.1157 2 19.7795V14.2205C2 13.8843 2.20174 13.5737 2.52924 13.4056L6.97076 11.1261Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9708 1.12606C16.2983 0.95798 16.7017 0.95798 17.0292 1.12606L21.4708 3.4056C21.7983 3.57368 22 3.8843 22 4.22046V9.77954C22 10.1157 21.7983 10.4263 21.4708 10.5944L17.0292 12.8739C16.7017 13.042 16.2983 13.042 15.9708 12.8739L11.5292 10.5944C11.2017 10.4263 11 10.1157 11 9.77954V4.22046C11 3.8843 11.2017 3.57368 11.5292 3.4056L15.9708 1.12606Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagons);
export default __webpack_public_path__ + "static/media/hexagons.97c824185db5e6e4b78e999a6e837c7e.svg";
export { ForwardRef as ReactComponent };